export const languageSnippets: Record<string, string> = {
  plaintext: `Hello, World!`,

  executable: `// Binary executables cannot be represented as code snippets.`,

  "assembly(nasm2.14.02)": `global _start

section .text
_start:
    mov     eax, 4
    mov     ebx, 1
    mov     ecx, message
    mov     edx, len
    int     0x80
    mov     eax, 1
    xor     ebx, ebx
    int     0x80

section .data
message db 'Hello, World!', 0xA
len equ $ - message`,

  "bash(5.0.0)": `echo "Hello, World!"`,

  "basic(fbc1.07.1)": `PRINT "Hello, World!"`,

  "c(gcc7.4.0)": `#include <stdio.h>
int main() {
    printf("Hello, World!\\n");
    return 0;
}`,

  "c(gcc8.3.0)": `#include <stdio.h>
int main() {
    printf("Hello, World!\\n");
    return 0;
}`,

  "c(gcc9.2.0)": `#include <stdio.h>
int main() {
    printf("Hello, World!\\n");
    return 0;
}`,

  "c#(mono6.6.0.161)": `using System;

class Program {
    static void Main() {
        Console.WriteLine("Hello, World!");
    }
}`,

  "c++(gcc7.4.0)": `#include <iostream>
int main() {
    std::cout << "Hello, World!" << std::endl;
    return 0;
}`,

  "c++(gcc8.3.0)": `#include <iostream>
int main() {
    std::cout << "Hello, World!" << std::endl;
    return 0;
}`,

  "c++(gcc9.2.0)": `#include <iostream>
int main() {
    std::cout << "Hello, World!" << std::endl;
    return 0;
}`,

  "c++(clang7.0.1)": `#include <iostream>
int main() {
    std::cout << "Hello, World!" << std::endl;
    return 0;
}`,

  "commonlisp(sbcl2.0.0)": `(format t "Hello, World!~%")`,

  "d(dmd2.089.1)": `import std.stdio;

void main() {
    writeln("Hello, World!");
}`,

  "elixir(1.9.4)": `IO.puts "Hello, World!"`,

  "erlang(otp22.2)": `-module(hello).
-export([hello_world/0]).

hello_world() ->
    io:fwrite("Hello, World!~n").`,

  "fortran(gfortran9.2.0)": `program hello
    print *, "Hello, World!"
end program hello`,

  "go(1.13.5)": `package main

import "fmt"

func main() {
    fmt.Println("Hello, World!")
}`,

  "haskell(ghc8.8.1)": `main :: IO ()
main = putStrLn "Hello, World!"`,

  "java(openjdk13.0.1)": `public class Main {
    public static void main(String[] args) {
        System.out.println("Hello, World!");
    }
}`,

  "javascript(node.js12.14.0)": `console.log("Hello, World!");`,

  "lua(5.3.5)": `print("Hello, World!")`,

  "ocaml(4.09.0)": `print_endline "Hello, World!"`,

  "octave(5.1.0)": `disp('Hello, World!')`,

  "pascal(fpc3.0.4)": `program HelloWorld;
begin
    writeln('Hello, World!');
end.`,

  "php(7.4.1)": `<?php
echo "Hello, World!";`,

  "prolog(gnuprolog1.4.5)": `:- initialization(main).

main :- write('Hello, World!'), nl.`,

  "python(2.7.17)": `print "Hello, World!"`,

  "python(3.8.1)": `print("Hello, World!")`,

  "ruby(2.7.0)": `puts "Hello, World!"`,

  "rust(1.40.0)": `fn main() {
    println!("Hello, World!");
}`,

  "typescript(3.7.4)": `console.log("Hello, World!");`,

  "c(clang7.0.1)": `#include <stdio.h>
int main() {
    printf("Hello, World!\\n");
    return 0;
}`,

  "cobol(gnucobol2.2)": `       IDENTIFICATION DIVISION.
       PROGRAM-ID. HELLO-WORLD.
       PROCEDURE DIVISION.
           DISPLAY 'Hello, World!'.
           STOP RUN.`,

  "kotlin(1.3.70)": `fun main() {
    println("Hello, World!")
}`,

  "objective-c(clang7.0.1)": `#import <Foundation/Foundation.h>

int main(int argc, const char * argv[]) {
    @autoreleasepool {
        NSLog(@"Hello, World!");
    }
    return 0;
}`,

  "r(4.0.0)": `cat("Hello, World!\\n")`,

  "scala(2.13.2)": `object HelloWorld {
    def main(args: Array[String]): Unit = {
        println("Hello, World!")
    }
}`,

  "sql(sqlite3.27.2)": `SELECT 'Hello, World!';`,

  "swift(5.2.3)": `print("Hello, World!")`,

  "visualbasic.net(vbnc0.0.0.5943)": `Module HelloWorld
    Sub Main()
        Console.WriteLine("Hello, World!")
    End Sub
End Module`,

  "perl(5.28.1)": `print "Hello, World!\\n";`,

  "clojure(1.10.1)": `(println "Hello, World!")`,

  "f#(.netcoresdk3.1.202)": `open System

[<EntryPoint>]
let main argv =
    printfn "Hello, World!"
    0`,

  "groovy(3.0.3)": `println 'Hello, World!'`,

  "multi-fileprogram": `// This is a placeholder for multi-file programs.`,
};

export const getSnippetByLanguage = (language: string): string => {
  const key = language.toLowerCase().replace(/\s+/g, "");
  return languageSnippets[key] || "// Write your code here";
};
